import { Table as MantineTable } from "@mantine/core";
export function BottomsTable() {
  return (
    <MantineTable>
      <MantineTable.Thead>
        <MantineTable.Tr>
          <MantineTable.Th>Size (KURB)</MantineTable.Th>
          <MantineTable.Th>Waist (inches)</MantineTable.Th>
          <MantineTable.Th>Waist (cm)</MantineTable.Th>
          <MantineTable.Th>EU</MantineTable.Th>
          <MantineTable.Th>JP</MantineTable.Th>
        </MantineTable.Tr>
      </MantineTable.Thead>
      <MantineTable.Tbody>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXXS</MantineTable.Td>
          <MantineTable.Td>19-21</MantineTable.Td>
          <MantineTable.Td>48-53</MantineTable.Td>
          <MantineTable.Td>34</MantineTable.Td>
          <MantineTable.Td>1</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXS</MantineTable.Td>
          <MantineTable.Td>21-23</MantineTable.Td>
          <MantineTable.Td>53-58.5</MantineTable.Td>
          <MantineTable.Td>36</MantineTable.Td>
          <MantineTable.Td>3</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXS</MantineTable.Td>
          <MantineTable.Td>23-25</MantineTable.Td>
          <MantineTable.Td>58.5-63.5</MantineTable.Td>
          <MantineTable.Td>38</MantineTable.Td>
          <MantineTable.Td>5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXS</MantineTable.Td>
          <MantineTable.Td>25-27</MantineTable.Td>
          <MantineTable.Td>63.5-68.5</MantineTable.Td>
          <MantineTable.Td>40</MantineTable.Td>
          <MantineTable.Td>7</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XS</MantineTable.Td>
          <MantineTable.Td>27-29</MantineTable.Td>
          <MantineTable.Td>68.5-73.5</MantineTable.Td>
          <MantineTable.Td>42</MantineTable.Td>
          <MantineTable.Td>7-9</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>S</MantineTable.Td>
          <MantineTable.Td>29-31</MantineTable.Td>
          <MantineTable.Td>73.5-79</MantineTable.Td>
          <MantineTable.Td>44-46</MantineTable.Td>
          <MantineTable.Td>9-11</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>M</MantineTable.Td>
          <MantineTable.Td>31-33</MantineTable.Td>
          <MantineTable.Td>79-84</MantineTable.Td>
          <MantineTable.Td>48-50</MantineTable.Td>
          <MantineTable.Td>11-13</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>L</MantineTable.Td>
          <MantineTable.Td>33-35</MantineTable.Td>
          <MantineTable.Td>84-89</MantineTable.Td>
          <MantineTable.Td>52-54</MantineTable.Td>
          <MantineTable.Td>13-17</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XL</MantineTable.Td>
          <MantineTable.Td>35-37</MantineTable.Td>
          <MantineTable.Td>89-94</MantineTable.Td>
          <MantineTable.Td>56</MantineTable.Td>
          <MantineTable.Td>17-19</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXL</MantineTable.Td>
          <MantineTable.Td>37-39</MantineTable.Td>
          <MantineTable.Td>94-99</MantineTable.Td>
          <MantineTable.Td>58</MantineTable.Td>
          <MantineTable.Td>19-21</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXL</MantineTable.Td>
          <MantineTable.Td>39-41</MantineTable.Td>
          <MantineTable.Td>99-104</MantineTable.Td>
          <MantineTable.Td>60</MantineTable.Td>
          <MantineTable.Td>21</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXL</MantineTable.Td>
          <MantineTable.Td>41-43</MantineTable.Td>
          <MantineTable.Td>104-109</MantineTable.Td>
          <MantineTable.Td>62</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXXL</MantineTable.Td>
          <MantineTable.Td>43-45</MantineTable.Td>
          <MantineTable.Td>109-114</MantineTable.Td>
          <MantineTable.Td>64</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
        </MantineTable.Tr>
      </MantineTable.Tbody>
    </MantineTable>
  );
}
